import { render, staticRenderFns } from "./regNewCompany.vue?vue&type=template&id=2bff0356&scoped=true&"
import script from "./regNewCompany.vue?vue&type=script&lang=js&"
export * from "./regNewCompany.vue?vue&type=script&lang=js&"
import style0 from "./regNewCompany.vue?vue&type=style&index=0&id=2bff0356&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bff0356",
  null
  
)

export default component.exports